import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Field, Label } from '@headlessui/react';
import { authApi } from '../api/endpoints';
import { useAuthStore } from '../stores/authStore';
import { showError } from '../stores/errorStore';
import SpotlightCard from '../components/ui/SpotlightCard';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';

export default function Login() {
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);

  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await authApi.login(formData.username, formData.password);

      if (response.success && response.data) {
        const { token, adminId } = response.data;
        login(token, adminId);
        navigate('/', { replace: true });
      } else {
        showError(response.error?.message || '登录失败', '登录失败');
      }
    } catch (err) {
      showError('网络错误，请稍后重试', '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <SpotlightCard className="p-10 w-full max-w-md backdrop-blur-3xl shadow-2xl shadow-black/40">
      <div className="text-center mb-10">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-white/5 mb-8 relative group">
          <div className="absolute inset-0 bg-white/10 rounded-3xl blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <svg className="w-10 h-10 text-white relative z-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h1 className="text-4xl font-bold text-white tracking-tighter mb-2">
          Drive Admin
        </h1>
        <p className="text-white/60 text-[10px] font-bold tracking-[0.2em] uppercase">
          Management Portal
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <Field className="space-y-2">
          <Label className="block text-[10px] font-bold uppercase tracking-[0.1em] text-white/20 ml-1">
            Username / 用户名
          </Label>
          <Input
            id="username"
            type="text"
            value={formData.username}
            onChange={(e) =>
              setFormData({ ...formData, username: e.target.value })
            }
            placeholder="Enter username"
            required
          />
        </Field>

        <Field className="space-y-2">
          <Label className="block text-[10px] font-bold uppercase tracking-[0.1em] text-white/20 ml-1">
            Password / 密码
          </Label>
          <Input
            id="password"
            type="password"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
            placeholder="Enter password"
            required
          />
        </Field>

        <Button
          type="submit"
          disabled={loading}
          size="lg"
          className="w-full h-14 rounded-2xl bg-white/5 hover:bg-white/10 text-white font-semibold transition-all duration-500 shadow-xl"
        >
          {loading ? '验证中...' : '进入系统'}
        </Button>
      </form>
    </SpotlightCard>
  );
}